/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/extensions */
import React, { Component } from 'react';

import Header from 'parts/Header';
import Footer from 'parts/Footer';

import { ORG_NAME, ORG_EMAIL } from '../constants';

export default class TermsPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <main id="main">
        <section className="container mx-auto px-4 md:px-12 py-16 lg:py-24">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl text-theme-blue font-serif font-bold leading-tight mb-8">
              Terms of Use
            </h1>
            <div className="text-lg text-gray-500 font-light leading-relaxed space-y-6">
              <p>
                Welcome to the {ORG_NAME} website. By using this website you agree to the terms below. If you do not agree, please do not continue to use the site.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">1. About this website</h2>
              <p>
                This website provides information about {ORG_NAME}, our programs, and ways to support our work. Content on this site is for informational purposes only and does not constitute legal, tax, or financial advice.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">2. Donations and tax-exempt status</h2>
              <p>
                {ORG_NAME} is incorporated as an Ohio nonprofit. 501(c)(3) federal tax-exempt status with the Internal Revenue Service is pending. Donations made before the IRS issues a determination may not be tax-deductible. Please consult your tax advisor about the deductibility of any contribution.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">3. Intellectual property</h2>
              <p>
                The content on this website — including text, images, logos, and design — is owned by {ORG_NAME} or its licensors. You may view and share this content for personal, educational, or noncommercial purposes with attribution. Any other use requires our written permission.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">4. Program participation</h2>
              <p>
                Enrollment in our programs is subject to separate participant agreements and family consent forms. Nothing on this website constitutes an offer of placement; placement is confirmed in writing through our intake process.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">5. External links</h2>
              <p>
                This website may link to other organizations and resources. We are not responsible for the content, privacy practices, or accuracy of those external sites.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">6. Contact</h2>
              <p>
                Questions about these terms? Email us at{' '}
                <a href={`mailto:${ORG_EMAIL}`} className="text-theme-purple hover:underline">{ORG_EMAIL}</a>
                .
              </p>

              <p className="mt-8 text-sm">
                Last updated: {new Date().toLocaleDateString()}
              </p>
            </div>
          </div>
        </section>
        </main>
        <Footer />
      </>
    );
  }
}
